module.exports = __webpack_public_path__ + "static/img/数据安全与合规.774ebb7e.png";